import { Box, Button, Card, CardContent, Grid, Typography } from '@mui/material'
import { SwapHoriz, Receipt, Pix } from '@mui/icons-material'

const actions = [
    {
        href: '/transferencia',
        icon: <SwapHoriz sx={{ color: '#3B82F6', fontSize: 28 }} />,
        iconBg: '#3B82F615',
        label: 'Transferir',
        sub: 'TED/PIX',
    },
    {
        href: '/pagamento',
        icon: <Receipt sx={{ color: '#8B5CF6', fontSize: 28 }} />,
        iconBg: '#8B5CF615',
        label: 'Pagar',
        sub: 'Boleto',
    },
    {
        href: '/transferencia',
        icon: <Pix sx={{ color: '#22C55E', fontSize: 28 }} />,
        iconBg: '#22C55E15',
        label: 'PIX',
        sub: 'Enviar',
    },
]

const QuickActions = () => (
    <Card
        sx={{
            height: '100%',
            border: '1px solid #E2E8F0',
            boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
            borderRadius: 3,
        }}
    >
        <CardContent sx={{ p: 3, '&:last-child': { pb: 3 } }}>
            <Typography variant="h6" sx={{ fontWeight: 600, color: '#1E293B', mb: 2.5 }}>
                Ações Rápidas
            </Typography>

            <Grid container spacing={2}>
                {actions.map((a) => (
                    <Grid item xs={4} key={a.label}>
                        <Box
                            component="a"
                            href={a.href}
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                gap: 1,
                                textDecoration: 'none',
                                p: 2,
                                borderRadius: 2,
                                border: '1px solid #E2E8F0',
                                transition: 'all .2s',
                                '&:hover': {
                                    bgcolor: '#F1F5F9',
                                    borderColor: '#3B82F6',
                                    transform: 'translateY(-2px)',
                                },
                            }}
                        >
                            <Box
                                sx={{
                                    width: 52,
                                    height: 52,
                                    borderRadius: '14px',
                                    bgcolor: a.iconBg,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                }}
                            >
                                {a.icon}
                            </Box>
                            <Typography variant="body2" sx={{ fontWeight: 600, color: '#1E293B' }}>
                                {a.label}
                            </Typography>
                            <Typography variant="caption" sx={{ color: '#94A3B8' }}>
                                {a.sub}
                            </Typography>
                        </Box>
                    </Grid>
                ))}
            </Grid>

            <Box sx={{ display: 'flex', gap: 1, mt: 2.5 }}>
                <Button
                    href="/pagamento/list"
                    variant="outlined"
                    fullWidth
                    size="small"
                    sx={{
                        textTransform: 'none',
                        fontWeight: 600,
                        borderRadius: 2,
                        borderColor: '#E2E8F0',
                        color: '#64748B',
                        '&:hover': { borderColor: '#94A3B8', bgcolor: '#F8FAFC' },
                    }}
                >
                    Histórico Pagamentos
                </Button>
                <Button
                    href="/limites"
                    variant="outlined"
                    fullWidth
                    size="small"
                    sx={{
                        textTransform: 'none',
                        fontWeight: 600,
                        borderRadius: 2,
                        borderColor: '#E2E8F0',
                        color: '#64748B',
                        '&:hover': { borderColor: '#94A3B8', bgcolor: '#F8FAFC' },
                    }}
                >
                    Limites
                </Button>
            </Box>
        </CardContent>
    </Card>
)

export default QuickActions
